module.exports = {
	extends: [
		'/',
		'templates',
		'mediaManagement',
		'media'
	],

	config: {
		listComponentClass: 'templates_mediaManagement_file_fileList',
		listElementComponentClass: 'base_form_media_file_file',
		nrOfElementsComponentClass: 'templates_mediaManagement_file_nrOfElements',
		listNewElementContainerClass: '.newFiles',
		getCategorizedMediaActionName: 'getCategorizedFiles'
	},

	methods: {
		dataDealer: function () {
			this.model.fileConfig = this.getResourceRegisterContent('fileConfig') || {};
			this.model.managementConfig = this.model.fileConfig.managementConfig || {};
		}
	}
};